import { t as e } from "./createApiQueryClient-DwmsEdyU.js";
import { r as t } from "./createEndpoints-BYEC3FIA.js";
//#region src/clients/customerPortal/createCustomerPortalApiClient.ts
var n = (e) => async (t, n) => {
	if (e.invalidateQueries?.length) {
		let r = await e.fetchFunction(t, n);
		if (r.error) {
			let e = /* @__PURE__ */ Error("Failed to fetch");
			throw Object.assign(e, { res: r.res }), e;
		}
		return r;
	}
	let r = await e.apiQueryClient.fetchQuery({
		queryFn: async () => {
			let r = await e.fetchFunction(t, n);
			if (r.error) {
				let e = /* @__PURE__ */ Error("Failed to fetch");
				throw Object.assign(e, { res: r.res }), e;
			}
			return r;
		},
		queryKey: [
			...e.queryKey,
			...t ? [t] : [],
			"legacy"
		]
	});
	return e.apiQueryClient.setQueryData([...e.queryKey, ...t ? [t] : []], r.data), e.apiQueryClient.removeQueries({ queryKey: [
		...e.queryKey,
		...t ? [t] : [],
		"legacy"
	] }), r;
}, r = (r) => {
	let i = {}, a = (e) => (t) => Object.entries(r.endpoints).forEach(([a, o]) => {
		let s = o(t), c = [
			...e.baseQueryKey ? [e.baseQueryKey] : [],
			..."queryKey" in o ? o.queryKey : ["No query key found"],
			r.version
		], l = [];
		"invalidateQueries" in o && (l = (o.invalidateQueries ?? []).map((t) => [...e.baseQueryKey ? [e.baseQueryKey] : [], ...Array.isArray(t) ? t : [t]]));
		let u = async (t, r) => {
			try {
				let i = await n({
					apiQueryClient: e.apiQueryClient,
					fetchFunction: s,
					queryKey: c,
					invalidateQueries: l
				})(t, r);
				return await Promise.all(l.map((t) => e.apiQueryClient.invalidateQueries({ queryKey: Array.isArray(t) ? t : [t] }))), i;
			} catch (e) {
				return {
					error: !0,
					res: e && typeof e == "object" && "res" in e ? e.res : { status: 500 },
					data: null
				};
			}
		};
		Object.assign(u, {
			request: (e, t) => s(e, t),
			queryKey: c,
			mocking: o.mocking,
			method: o.method,
			version: r.version,
			invalidateQueries: l,
			..."paramQueryKeyTransform" in o ? { paramQueryKeyTransform: o.paramQueryKeyTransform } : {}
		}), i[a] = u;
	}, {}), o = (n) => {
		let i = t(n.apiOrigin, { headers: {
			"Sequence-Version": r.version,
			...n.defaultHeaders ?? {},
			"Sequence-Audience": "internal"
		} });
		a({
			apiQueryClient: n.apiQueryClient ?? e(),
			baseQueryKey: n.baseQueryKey
		})(i);
	};
	return o({ apiOrigin: "" }), i.initialize = o, i;
};
//#endregion
export { r as t };

//# sourceMappingURL=createCustomerPortalApiClient-D9X6mqNb.js.map